"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _formik = require("formik");

var _reactRouterDom = require("react-router-dom");

var _location = require("@devsontap/nica-api/core/models/location");

var _lodash = _interopRequireDefault(require("lodash"));

var _notistack = require("notistack");

var _core = require("@material-ui/core");

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Save = _interopRequireDefault(require("@material-ui/icons/Save"));

var _info = _interopRequireDefault(require("./info"));

var _loading = _interopRequireDefault(require("../../../_common/loading"));

var _selectors = require("../../../../redux/locationManager/selectors");

var _selectors2 = require("../../../../redux/login/selectors");

var _attributes = require("../../../../redux/attributes");

var _locationManager = require("../../../../redux/locationManager");

var _images = _interopRequireDefault(require("./images"));

var _medications = _interopRequireDefault(require("./medications"));

var _practiceDetails = _interopRequireDefault(require("./practiceDetails"));

var _additional = _interopRequireDefault(require("./additional"));

var _btnCancel = _interopRequireDefault(require("../../../../img/btn-cancel.svg"));

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var LocationDetails = function LocationDetails(_ref) {
  var locationId = _ref.locationId,
      orgId = _ref.orgId;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      saving = _useState2[0],
      setSaving = _useState2[1];

  var _useLocationDetailsSe = (0, _selectors.useLocationDetailsSelector)(locationId),
      location = _useLocationDetailsSe.location;

  var history = (0, _reactRouterDom.useHistory)();

  var _useLoginSelector = (0, _selectors2.useLoginSelector)(),
      _useLoginSelector$cla = _useLoginSelector.claims,
      email = _useLoginSelector$cla.email,
      uid = _useLoginSelector$cla.uid,
      displayName = _useLoginSelector$cla.displayName,
      admin = _useLoginSelector$cla.admin;

  var attributes = (0, _attributes.useAttributeInflatorSelector)();

  var _useAttributeListSele = (0, _attributes.useAttributeListSelector)(),
      attributesLoading = _useAttributeListSele.loading;

  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSnackbar = (0, _notistack.useSnackbar)(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar;

  var submitRef = (0, _react.useRef)(null);

  var onClose = function onClose() {
    return history.push('/admin');
  };

  (0, _react.useEffect)(function () {
    if (!location) {
      dispatch((0, _locationManager.fetchLocation)(locationId, enqueueSnackbar, function () {
        onClose();
      }));
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return attributesLoading || !location ? /*#__PURE__*/_react.default.createElement(_loading.default, {
    size: 45
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: "bg-appPage min-h-full overflow-y-scroll"
  }, /*#__PURE__*/_react.default.createElement(_core.AppBar, {
    position: "sticky",
    color: "primary"
  }, /*#__PURE__*/_react.default.createElement(_core.Toolbar, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex w-full"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    onClick: onClose
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _btnCancel.default,
    alt: "close button"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "text-2xl text-[#fffff] font-bold flex items-center ml-6"
  }, locationId === "add" ? "Add" : "Edit", " Location"), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex-1 flex justify-end items-center"
  }, saving ? /*#__PURE__*/_react.default.createElement(_CircularProgress.default, {
    size: 30,
    color: "default"
  }) : /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "text",
    color: "secondary",
    onClick: function onClick() {
      var _submitRef$current;

      return (_submitRef$current = submitRef.current) === null || _submitRef$current === void 0 ? void 0 : _submitRef$current.click();
    }
  }, /*#__PURE__*/_react.default.createElement(_Save.default, {
    className: "mr-1",
    htmlColor: "#ffffff"
  }), " ", /*#__PURE__*/_react.default.createElement("span", {
    className: "text-[#ffffff]"
  }, "Save")))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "mb-10"
  }, /*#__PURE__*/_react.default.createElement(_formik.Formik, {
    initialValues: _getDefaultValues(location, orgId, uid, email, displayName, attributes),
    onSubmit: function onSubmit(values) {
      setSaving(true);
      dispatch((0, _locationManager.saveLocation)(values, setSaving, onClose, false, enqueueSnackbar));
    },
    validationSchema: _location.SCHEMA,
    validateOnChange: false
  }, function (_ref2) {
    var values = _ref2.values,
        errors = _ref2.errors,
        touched = _ref2.touched,
        handleChange = _ref2.handleChange,
        handleSubmit = _ref2.handleSubmit,
        isSubmitting = _ref2.isSubmitting,
        setFieldValue = _ref2.setFieldValue,
        submitCount = _ref2.submitCount,
        isValid = _ref2.isValid;
    return /*#__PURE__*/_react.default.createElement(_formik.Form, null, /*#__PURE__*/_react.default.createElement("input", {
      type: "Submit",
      className: "hidden",
      ref: submitRef
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "pt-10"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "flex justify-center"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "max-w-screen-md flex-1"
    }, /*#__PURE__*/_react.default.createElement(_core.Accordion, {
      defaultExpanded: true
    }, /*#__PURE__*/_react.default.createElement(_core.AccordionSummary, {
      className: "font-oswald text-2xl",
      expandIcon: /*#__PURE__*/_react.default.createElement(_ExpandMore.default, null)
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "text-darkBlue"
    }, "Location Information")), /*#__PURE__*/_react.default.createElement(_core.AccordionDetails, null, /*#__PURE__*/_react.default.createElement(_info.default, {
      values: values,
      errors: errors,
      setFieldValue: setFieldValue
    }))), (admin || values.isMember) && /*#__PURE__*/_react.default.createElement(_core.Accordion, null, /*#__PURE__*/_react.default.createElement(_core.AccordionSummary, {
      className: "font-oswald text-2xl",
      expandIcon: /*#__PURE__*/_react.default.createElement(_ExpandMore.default, null)
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "text-darkBlue"
    }, "Images")), /*#__PURE__*/_react.default.createElement(_core.AccordionDetails, null, /*#__PURE__*/_react.default.createElement(_images.default, {
      photos: values.photos,
      streetViewImage: values.google_street_view_image,
      handleChange: handleChange
    }))), /*#__PURE__*/_react.default.createElement(_core.Accordion, null, /*#__PURE__*/_react.default.createElement(_core.AccordionSummary, {
      className: "font-oswald text-2xl",
      expandIcon: /*#__PURE__*/_react.default.createElement(_ExpandMore.default, null)
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "text-darkBlue"
    }, "Medications Available")), /*#__PURE__*/_react.default.createElement(_core.AccordionDetails, null, /*#__PURE__*/_react.default.createElement(_medications.default, {
      setFieldValue: setFieldValue
    }))), /*#__PURE__*/_react.default.createElement(_core.Accordion, null, /*#__PURE__*/_react.default.createElement(_core.AccordionSummary, {
      className: "font-oswald text-2xl",
      expandIcon: /*#__PURE__*/_react.default.createElement(_ExpandMore.default, null)
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "text-darkBlue"
    }, "Practice Details")), /*#__PURE__*/_react.default.createElement(_core.AccordionDetails, null, /*#__PURE__*/_react.default.createElement(_practiceDetails.default, {
      setFieldValue: setFieldValue
    }))), /*#__PURE__*/_react.default.createElement(_core.Accordion, null, /*#__PURE__*/_react.default.createElement(_core.AccordionSummary, {
      className: "font-oswald text-2xl",
      expandIcon: /*#__PURE__*/_react.default.createElement(_ExpandMore.default, null)
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "text-darkBlue"
    }, "Additional Information")), /*#__PURE__*/_react.default.createElement(_core.AccordionDetails, null, /*#__PURE__*/_react.default.createElement(_additional.default, {
      setFieldValue: setFieldValue,
      handleChange: handleChange,
      temporarilyClosed: values.temporarily_closed
    })))))));
  })));
};

function _getDefaultValues(location, orgId, uid, userEmail, displayName, attributes) {
  return _objectSpread(_objectSpread({
    active: false,
    name: "",
    address: {
      line1: "",
      line2: "",
      city: "",
      stateCode: "",
      zip: ""
    },
    phoneNumber: "",
    numberOfChairs: 0,
    description: "",
    emailAddress: "",
    faxNumber: "",
    url: "",
    isPreferred: false,
    orgId: location && location.id ? location.orgId : orgId,
    addedBy: {
      uid: uid,
      userEmail: userEmail,
      displayName: displayName
    },
    businessHours: {},
    facebookPageId: "",
    twitterHandle: "",
    languagesSpoken: "",
    temporarily_closed: false,
    temporarily_closed_reason: "",
    photos: [],
    latitude: -1,
    longitude: -1,
    businessHoursTemporarilyAffected: false,
    businessHoursTemporaryMessage: ''
  }, location), {}, {
    attributes: _getDefaultAttributeValues(location, attributes)
  });
}

function _getDefaultAttributeValues(location, attributes) {
  var result = attributes.reduce(function (ret, attribute) {
    ret[attribute.key] = _lodash.default.merge({
      required: Boolean(attribute.required),
      name: attribute.name,
      choice: []
    }, location && location.attributes && location.attributes[attribute.key] ? location.attributes[attribute.key] : {});

    if (attribute.groups) {
      Object.keys(attribute.groups).forEach(function (groupKey) {
        ret[groupKey] = _lodash.default.merge({
          required: Boolean(attribute.groups[groupKey].required),
          name: attribute.groups[groupKey].name,
          choice: []
        }, location && location.attributes && location.attributes[groupKey] ? location.attributes[groupKey] : {});
      });
    }

    return ret;
  }, location && location.attributes ? _objectSpread({}, location.attributes) : {});
  return result;
}

var _default = LocationDetails;
exports.default = _default;